var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.25C9.51878 10.25 10.75 9.01878 10.75 7.5C10.75 5.98122 9.51878 4.75 8 4.75C6.48122 4.75 5.25 5.98122 5.25 7.5C5.25 9.01878 6.48122 10.25 8 10.25Z",
    fill: "#1C86F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4967 6.27711 13.8108 4.62573 12.5925 3.40746C11.3743 2.18918 9.72289 1.5033 8 1.5ZM12.1125 11.65C11.7078 11.0694 11.1862 10.5798 10.5813 10.2125C9.88666 10.8779 8.96191 11.2494 8 11.2494C7.03809 11.2494 6.11334 10.8779 5.41875 10.2125C4.8138 10.5798 4.29224 11.0694 3.8875 11.65C3.18361 10.8574 2.72378 9.87819 2.56335 8.83034C2.40292 7.78248 2.54873 6.71059 2.98322 5.74366C3.41772 4.77673 4.12238 3.95596 5.01242 3.38014C5.90246 2.80431 6.93994 2.49797 8 2.49797C9.06007 2.49797 10.0975 2.80431 10.9876 3.38014C11.8776 3.95596 12.5823 4.77673 13.0168 5.74366C13.4513 6.71059 13.5971 7.78248 13.4367 8.83034C13.2762 9.87819 12.8164 10.8574 12.1125 11.65Z",
    fill: "#1C86F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/userCircle.f7dccb6069607b7d3e51698274b45712.svg";
export { ForwardRef as ReactComponent };